var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v("Inicio de Sesión")]),_c('p',[_vm._v("Ingrese su RUT y contraseña para acceder.")]),_c('sign-in-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }